export const SESSION_KEY_LEASE_APPLICATION = '__lease_application__';
export const GLOBAL_CONTEXT_KEY_APP_RESULT = '__appliction_result__';
export const GLOBAL_CONTEXT_KEY_INVOICE_RESULT = '__invoice_result__';
export const SESSION_KEY_INVOICE = '__invoice__';
export const GLOBAL_CONTEXT_KEY_APPROVAL_AMOUNT = 'approvalAmount';
